import { Promise } from "core-js";
import { route, get } from "@utils/network";

export default {
    state: {
        shop: null,
        shopSearchParams: {
            is_home: 0,
            booking_type: "in-shop",
            datetime: null,
        },
        services: [],
        packages: [],
        bookingStats: {
            availablePoints: 0,
            violationLimit: 0,
            pointEquivalent: 0,
            unsettledPenalties: 0,
        },
        paymentOptions: [
            { text: "Payment on establishment", value: "cash" },
            { text: "Pay via GCash", value: "gcash" }
        ],
    },
    
    mutations: {
        SET_SHOP(state, shop) {
            state.shop = shop;
        },
        SET_SCHEDULE_PARAMS(state, params) {
            state.shopSearchParams = params;
        },
        SET_PACKAGES(state, packages) {
            state.packages = Array.isArray(packages) && packages.length > 0
                ? [...packages]
                : null;
        },
        SET_SERVICES(state, services) {
            state.services = Array.isArray(services) && services.length > 0
                ? [...services]
                : null;
        },
        SET_BOOKING_STATS(state, stats) {
            state.bookingStats.availablePoints = parseFloat(stats.availablePoints);
            state.bookingStats.violationLimit = parseFloat(stats.violationLimit);
            state.bookingStats.pointEquivalent = parseFloat(stats.pointEquivalent);
            state.bookingStats.unsettledPenalties = parseFloat(stats.unsettledPenalties);
        },

    },
    actions: {
        setAddress(context, address) {
            context.commit("SET_ADDRESS", address);
        },
        setShop(context, shop) {
            context.commit("SET_SHOP", shop);
        },
        setScheduleParams(context, params) {
            context.commit("SET_SCHEDULE_PARAMS", params);
        },
        setServicesAndPackages(context, { services, packages }) {
            context.commit("SET_SERVICES", services);
            context.commit("SET_PACKAGES", packages);
        },
        getBookingStats(context) {
            return new Promise((resolve, reject) => {
                get(route("booking-stats"))
                    .then(response => {
                        context.commit("SET_BOOKING_STATS", {
                            availablePoints: parseFloat(response.data.result.availablePoints),
                            violationLimit: parseFloat(response.data.result.violationLimit),
                            pointEquivalent: parseFloat(response.data.result.pointEquivalent),
                            unsettledPenalties: parseFloat(response.data.result.unsettledPenalties),
                        });
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
            
        },

    },
    getters: {
        shop(context) {
            return context.shop;
        },
        shopSearchParams(context) {
            return context.shopSearchParams;
        },
        services(context) {
            return context.services;
        },
        packages(context) {
            return context.packages;
        },
        bookingStats(context) {
            return context.bookingStats;
        },
        paymentOptions(context) {
            return context.paymentOptions;
        },
        userToken(context) {
            return localStorage.getItem("auth_token") || null;
        },
    }
};
